import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFandomComponent } from './simple-icons-fandom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFandomComponent ],
    exports:      [ SimpleIconsFandomComponent ],
    bootstrap:    []
})
export class SimpleIconsFandomModule {}
